/**
 * Map a status label to its CSS badge class. Multi-word statuses ("In Progress",
 * "Pending Exam") become hyphenated class names (`b-In-Progress`) since spaces
 * aren't valid in a className. See the `.b-*` rules in admin.css.
 */
export const badgeClass = (status: string): string => `badge b-${status.replace(/\s+/g, "-")}`;
